import { useMsal } from '@azure/msal-react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiFetch, type AdminUser, type OrgRole } from './client';

export function useUsers() {
  const { instance } = useMsal();
  return useQuery({
    queryKey: ['users'],
    queryFn: () => apiFetch<AdminUser[]>(instance, '/api/users'),
  });
}

export function useGrantRole() {
  const { instance } = useMsal();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ userId, role }: { userId: string; role: OrgRole }) =>
      apiFetch(instance, `/api/users/${userId}/roles`, {
        method: 'POST',
        body: JSON.stringify({ role }),
      }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['users'] }),
  });
}

export function useRevokeRole() {
  const { instance } = useMsal();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ userId, role }: { userId: string; role: OrgRole }) =>
      apiFetch(instance, `/api/users/${userId}/roles/${role}`, { method: 'DELETE' }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['users'] }),
  });
}

export function useSetActive() {
  const { instance } = useMsal();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ userId, active }: { userId: string; active: boolean }) =>
      apiFetch(instance, `/api/users/${userId}`, {
        method: 'PATCH',
        body: JSON.stringify({ active }),
      }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['users'] }),
  });
}
